import { GlobalHeaderState, SwgyHeaderKeysList, getBridgeSdk } from "@swiggy-private/checkout-core";
import { STORAGE_TYPES, StorageResponsePayload } from "@swiggy-private/native-bridge";

import { OFFER_BUNDLE_HALF_CARD_SID } from "@cart-client/constants/StorageKeys";

export const currentSid = () => GlobalHeaderState.getHeader(SwgyHeaderKeysList.sid) || "0";

export const getSidForWhichHalfCardIsVisible = async (): Promise<string | undefined | null> => {
    try {
        const response = await getBridgeSdk().storage({
            type: STORAGE_TYPES.GET,
            data: {
                [OFFER_BUNDLE_HALF_CARD_SID]: "",
            },
        });

        const sid = response?.data?.[OFFER_BUNDLE_HALF_CARD_SID];

        if (!sid) {
            return Promise.resolve(null);
        }

        return Promise.resolve(sid);
    } catch (e) {
        return Promise.resolve(null);
    }
};

export const updateSidForWhichHalfCardIsVisible = async (sid: string): Promise<StorageResponsePayload | undefined> =>
    await getBridgeSdk().storage({
        type: STORAGE_TYPES.SAVE,
        data: {
            [OFFER_BUNDLE_HALF_CARD_SID]: sid,
        },
    });
